/**
 * Keep "a" from firing and call the function; Protect Your A!
 * @param run_function The function to run
 * @param bindThis the "this" for the resulting function call; can be false to use the event (jquery style) or for React can be the react component
 * @returns {Function}
 */
export default function handleEvent(run_function, bindThis) {
	return function(e) {
		if (e.preventDefault) {
			e.preventDefault();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}

		// react support
		if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
			e.nativeEvent.stopImmediatePropagation();
		}

		// react needs "this" to be the react component
		if (bindThis) {
			run_function.bind(bindThis)(e);
		} else {
			// call sets "this" of the called function
			// the called function behaves as if jquery had called it by giving it the triggering element
			run_function.call(e.target, e);
		}
	};
}

// What does handleEvent do? I don't know. What does Protect A do? It protects your <a>!!!
export const protectA = handleEvent;